module.exports = __webpack_public_path__ + "assets/img/dgoods-step1-active-green.b553e8d7.svg";